import React, { useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  Button,
  Typography,
  Grid,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

// interns scriptrunner - ManualParametersV2 component to allow Case B manual inputs
const ManualParametersV2 = ({ onChange, disabled }) => {
  const [params, setParams] = useState([{ key: "", value: "" }]);

  // interns scriptrunner - update state and notify parent component
  const updateParams = (newParams) => {
    setParams(newParams);
    const inputObj = {};
    newParams.forEach((p) => {
      if (p.key.trim()) inputObj[p.key.trim()] = p.value;
    });
    onChange(inputObj);
  };

  const handleAddParam = () => {
    updateParams([...params, { key: "", value: "" }]);
  };

  const handleRemoveParam = (index) => {
    const newParams = params.filter((_, i) => i !== index);
    updateParams(newParams);
  };

  const handleChange = (index, field, value) => {
    const newParams = [...params];
    newParams[index][field] = value;
    updateParams(newParams);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#666" }}
      >
        Manual Configuration (Case B: No template.json)
      </Typography>
      {params.map((param, index) => (
        <Grid
          container
          spacing={1}
          key={index}
          sx={{ mb: 1, alignItems: "center" }}
        >
          <Grid item xs={5}>
            <TextField
              size="small"
              fullWidth
              label="Key"
              value={param.key}
              onChange={(e) => handleChange(index, "key", e.target.value)}
              placeholder="e.g. domain"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              size="small"
              fullWidth
              label="Value"
              value={param.value}
              onChange={(e) => handleChange(index, "value", e.target.value)}
              placeholder="e.g. example.com"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={2}>
            <Tooltip title="Remove Parameter">
              <span>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleRemoveParam(index)}
                  disabled={disabled}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      ))}
      <Button
        startIcon={<AddIcon />}
        size="small"
        onClick={handleAddParam}
        sx={{ mt: 1 }}
        disabled={disabled}
      >
        Add Parameter
      </Button>
    </Box>
  );
};

export default ManualParametersV2;
